import React, { useContext, useMemo, useState } from "react";
import Bandhuimg from "../../assets/images/Bandhu JC (1).svg";
import CLosedimg from "../../assets/images/Closed JC (1).svg";
import Totalimg from "../../assets/images/Total JC (1).svg";
import Openimg from "../../assets/images/Open JC.svg";
import { ServicesContext } from "../../context/ServicesDataProvider";
import { FaArrowUpRightFromSquare } from "react-icons/fa6";
import { Link } from "react-router-dom";

const JCDescription = () => {
  const {
    totalJobcardData,
    openJobcardData,
    bandhuappJcData,
    totalJcBs6Data,
    openJcBs6Data,
    closedjcBs6Data,
    totalJcNonBs6Data,
    openJcNonBs6Data,
    closedJcNonBs6Data,
  } = useContext(ServicesContext);

  const [selectedOption, setSelectedOption] = useState("All");

  const { totalJC, openJC, closedJC } = useMemo(() => {
    if (selectedOption === "BS6") {
      return {
        totalJC: totalJcBs6Data[0]?.doc_count ?? 0,
        openJC: openJcBs6Data[0]?.countOpenJc.doc_count ?? 0,
        closedJC: closedjcBs6Data[0]?.countCloseJc?.doc_count ?? 0,
      };
    } else if (selectedOption === "Non-BS6") {
      return {
        totalJC: totalJcNonBs6Data[0]?.doc_count ?? 0,
        openJC: openJcNonBs6Data[0]?.countOpenJc?.doc_count ?? 0,
        closedJC: closedJcNonBs6Data[0]?.countCloseJc?.doc_count ?? 0,
      };
    } else {
      return {
        totalJC: totalJobcardData?.doc_count ?? 0,
        openJC: openJobcardData?.doc_count ?? 0,
        closedJC:
          (totalJobcardData?.doc_count ?? 0) -
          (openJobcardData?.doc_count ?? 0),
      };
    }
  }, [
    selectedOption,
    totalJobcardData,
    openJobcardData,
    totalJcBs6Data,
    openJcBs6Data,
    closedjcBs6Data,
    totalJcNonBs6Data,
    openJcNonBs6Data,
    closedJcNonBs6Data,
  ]);
  return (
    <div className="flex flex-col bg-white rounded-lg shadow-lg overflow-hidden">
      {/* Header Section */}
      <div className="bg-[#2374BF] text-white pr-1 rounded-t-lg flex justify-between items-center">
        <h2 className="text-md font-semibold pl-2 p-1">JC Description</h2>
        <div className="flex items-center space-x-4">
          <div className="relative">
            <select
              value={selectedOption}
              onChange={(e) => setSelectedOption(e.target.value)}
              className="block appearance-none bg-[#FFFFFF66] border border-gray-300 py-1 px-4 pr-8 rounded leading-tight focus:outline-none focus:border-gray-300 text-sm text-white"
              style={{
                backdropFilter: "blur(30px)",
                boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
              }}
            >
              <option className="text-black">All</option>
              <option className="text-black">BS6</option>
              <option className="text-black">Non-BS6</option>
            </select>
            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-white">
              <svg
                className="fill-current h-4 w-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
              </svg>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content Grid */}
      <div className="grid grid-cols-2 gap-4 p-4">
        {/* Total JC Card */}
        <div className="flex items-center justify-between bg-[#C8FAFF] p-3 rounded-md shadow-md">
          <div className="flex items-center space-x-3">
            <img
              src={Bandhuimg}
              alt="Total JC"
              className="h-18 w-16 object-contain"
            />
            <h1 className="text-md font-medium">Total JC</h1>
          </div>
          <h6 className="text-lg font-semibold">{totalJC}</h6>
        </div>

        {/* Open JC Card */}
        <div className="flex items-center justify-between bg-[#FFCFD6] p-3 rounded-md shadow-md">
          <div className="flex items-center space-x-3">
            <img
              src={Openimg}
              alt="Open JC"
              className="h-15 w-16 object-contain"
            />
            <h1 className="text-md font-medium">Open JC</h1>
          </div>
          <h6 className="text-lg font-semibold">{openJC}</h6>
        </div>

        {/* Closed JC Card */}
        <div className="flex items-center justify-between bg-[#C6FFE7] p-3 rounded-md shadow-md">
          <div className="flex items-center space-x-3">
            <img
              src={CLosedimg}
              alt="Closed JC"
              className="h-12 w-16 object-contain"
            />
            <h1 className="text-md font-medium">Closed JC</h1>
          </div>
          <h6 className="text-lg font-semibold">{closedJC}</h6>
        </div>

        {/* Bandhu JC Card */}
        <div className="flex items-center justify-between bg-[#D0EBFF] p-3 rounded-md shadow-md">
          <div className="flex items-center space-x-3">
            <img
              src={Totalimg}
              alt="Bandhu JC"
              className="h-12 w-16 object-contain"
            />
            <h1 className="text-md font-medium">Bandhu JC</h1>
          </div>
          <h6 className="text-lg font-semibold">
            {bandhuappJcData?.doc_count ?? 0}
          </h6>
        </div>
      </div>

      {/* Buttons Section */}
      <div className="flex justify-around p-4 border-t border-gray-200">
        <Link
          to="/jc"
          className="flex gap-2 items-center bg-gradient-to-r from-[#0070C0] to-[#4EB5FF] py-1 px-6 rounded-full text-white shadow-md hover:opacity-90 transition-all"
        >
          <p>JC Details</p>
          <FaArrowUpRightFromSquare />
        </Link>
        <Link
          to={"/Jobcard"}
          className="flex gap-2 items-center bg-gradient-to-r from-[#0F83A6] to-[#5AE8DF] py-1 px-6 rounded-full bg-blue-500 text-white shadow-md hover:bg-blue-600 transition-colors"
        >
          <p>Live JC</p> <FaArrowUpRightFromSquare />
        </Link>
      </div>
    </div>
  );
};

export default JCDescription;
